import { ArrowRightLeft, Ban, Contact, Merge } from "lucide-react";

import EntryDetails from "components/LogItem/elements/EntryDetails";
import { getModelLink } from "components/LogItem/messages/modelLinks";

const contactLinkFor = ({ contact_id, contact_name }) =>
  getModelLink(contact_id, "Contact", { label: contact_name });

export const CONTACT_EVENTS = {
  unsubscribed: {
    title: "Contact Unsubscribed",
    icon: Ban,
    message: item => {
      const { user_name, info } = item;
      const change = info.changes?.[0];
      return (
        <>
          <p>
            The email address {info.email} of {contactLinkFor(item)} was
            unsubscribed.
          </p>
          <EntryDetails
            rows={[
              { label: "Campaign", value: info.campaign_name },
              { label: "Changed By", value: user_name || "System" },
              {
                label: "Change",
                value:
                  change &&
                  `${change.attribute} changed from '${String(
                    change.previous_value
                  )}' to '${String(change.value)}'`,
              },
              { label: "Reason", value: info.reason },
            ]}
          />
        </>
      );
    },
  },
  contact_moved: {
    title: "Contact Moved",
    icon: ArrowRightLeft,
    message: item => {
      const { prev_entity } = item.info;
      return (
        <p>
          {contactLinkFor(item)} was moved from{" "}
          {getModelLink(prev_entity.id, "Entity", { label: prev_entity.name })}{" "}
          to{" "}
          {getModelLink(item.entity_id, "Entity", { label: item.entity_name })}.
        </p>
      );
    },
  },
  contact_merged: {
    title: "Contact Merged",
    icon: Merge,
    message: item => {
      const { merged_contact } = item.info;
      return (
        <>
          <p>
            {item.user_name} merged the contact {merged_contact.full_name} into{" "}
            {contactLinkFor(item)}.
          </p>
          <EntryDetails
            rows={[
              { label: "Merged Contact ID", value: merged_contact.id },
              { label: "Kept Contact ID", value: item.contact_id },
            ]}
          />
        </>
      );
    },
  },
  entity_merged: {
    title: "Entity Merged",
    icon: Merge,
    message: ({
      user_name,
      entity_id,
      entity_name,
      info: { merged_entity },
    }) => (
      <>
        <p>
          {user_name} merged the entity {merged_entity.name} into{" "}
          {getModelLink(entity_id, "Entity", { label: entity_name })}.
        </p>
        <EntryDetails
          rows={[
            { label: "Merged Entity ID", value: merged_entity.id },
            { label: "Kept Entity ID", value: entity_id },
          ]}
        />
      </>
    ),
  },
  referred_by_contact: {
    title: "Referred by Contact",
    icon: Contact,
    message: item => {
      const { referred_by_contact, notes } = item.info;
      return (
        <>
          <p>
            {contactLinkFor(item)} was referred by{" "}
            {referred_by_contact.full_name}.
          </p>
          <EntryDetails rows={[{ label: "Notes", value: notes }]} />
        </>
      );
    },
  },
  referred_contact: {
    title: "Referred Contact",
    icon: Contact,
    message: item => {
      const { referred_contact, notes } = item.info;
      return (
        <>
          <p>
            {contactLinkFor(item)} referred {referred_contact.full_name}.
          </p>
          <EntryDetails rows={[{ label: "Notes", value: notes }]} />
        </>
      );
    },
  },
};
